import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import { DarkPrimaryButton } from 'components'
import MoreFromHostButton from './MoreFromHostButton'
import MyTicketButton from './MyTicketButton'
import PrimaryButton from './PrimaryButton'

const TicketButton = ({
  className,
  eventData,
  history,
  onReserve,
  showPrice,
  user,
  hostName,
  linkId,
  event,
  ...rest
}) => {
  const classNames = classnames(className, 'text-sm uppercase')
  const {
    id,
    isCompleted,
    isCancelled,
    userSignedUpAlready,
    ticketPriceString,
    ticketsHaveSoldOut,
  } = eventData
  const eventToReserve = { ...event, id }

  if (!user) {
    return (
      <PrimaryButton
        className={classNames}
        data-cy="reserve-btn"
        onClick={() => onReserve(eventToReserve)}
        {...rest}
      >
        Reserve
      </PrimaryButton>
    )
  }

  if (isCompleted) {
    return <MoreFromHostButton linkId={linkId} hostName={hostName} history={history} />
  }

  if (isCancelled) {
    return (
      <DarkPrimaryButton className={classNames} {...rest}>
        Cancelled
      </DarkPrimaryButton>
    )
  }

  if (userSignedUpAlready) {
    return (
      <MyTicketButton
        className={classNames}
        user={user}
        event={event}
        eventData={eventData}
        {...rest}
      />
    )
  }

  if (ticketsHaveSoldOut) {
    return (
      <DarkPrimaryButton className={classNames} {...rest}>
        Sold out
      </DarkPrimaryButton>
    )
  }

  return (
    <PrimaryButton
      className={classNames}
      data-cy="reserve-btn"
      onClick={() => onReserve(eventToReserve)}
      {...rest}
    >
      Reserve {showPrice && ticketPriceString}
    </PrimaryButton>
  )
}

TicketButton.propTypes = {
  showPrice: PropTypes.bool,
  linkId: PropTypes.string,
  hostName: PropTypes.string,
  onReserve: PropTypes.func,
  onClick: PropTypes.func,
  history: PropTypes.object,
  eventData: PropTypes.object,
  user: PropTypes.object,
}

export default TicketButton
